import Link from "next/link";
import type { ReactNode } from "react";

export interface ContextualLink {
  text: string;
  href: `/${string}`;
}

/** Render explicitly selected phrases in plain editorial text as internal links. */
export function ContextualText({
  text,
  links = [],
}: {
  text: string;
  links?: readonly ContextualLink[];
}) {
  const matches = links
    .filter((link) => link.text.length > 0)
    .map((link) => ({ ...link, start: text.indexOf(link.text) }))
    .filter((link) => link.start >= 0)
    .sort((a, b) => a.start - b.start || b.text.length - a.text.length);
  const children: ReactNode[] = [];
  let cursor = 0;

  for (const link of matches) {
    if (link.start < cursor) continue;
    children.push(text.slice(cursor, link.start));
    children.push(
      <Link
        key={`${link.start}:${link.href}`}
        href={link.href}
        className="text-primary underline underline-offset-4 hover:no-underline"
      >
        {link.text}
      </Link>,
    );
    cursor = link.start + link.text.length;
  }

  children.push(text.slice(cursor));
  return <>{children}</>;
}
